// This list of payment methods were taken from the backend `Fact.php` file line 25
//type PAYMENT_METHOD = 'cash' | 'check' | 'cards' | 'check_true' | 'pay_pal' | 'bill' | 'others' | 'ebanking';

import CreditCard from './CreditCard';

// ebanking = Bank Transfer
export type PAYMENT_METHOD = 'cards' | 'pay_pal' | 'ebanking';

export default class Payment {
  method: PAYMENT_METHOD | undefined = undefined;
  gateway!: string;
  card?: CreditCard;

  constructor(data?: Dict) {
    Object.assign(this, data);
    this.method = data?.method || undefined;
    this.gateway = data?.gateway || 'tokenex';
  }
}
